<template>
    <div class="center-box singCar-left">
        <!-- <title1 title="综合态势" :isBg="false" fontSize="32" /> -->
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex align-center target4">
                <img class="img" :src="item.icon" />
                <div class="flex flex-direction" :title="item.number">
                    <div class="label">{{ item.label}}</div>
                    <div class="num text flex align-center" :style="{'color': item.color}">{{ item.number }}</div>
                </div>
            </div>
    </div>
</template>

<script>
// import title1 from '@/views/exposition/components/title1'
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
    components: {
        // title1
    },
    data() {
        return {
            target1: [
                {
                    icon: require('@/assets/images/exposition/chd-3.png'),
                    number: '',
                    label: '电池编码',
                    color: '#36FBFB'
                },
                {
                    icon: require('@/assets/images/exposition/car-5.png'),
                    number: '',
                    label: '生产商',
                    color: '#43FFB9'
                },
                {
                    icon: require('@/assets/images/exposition/car-2.png'),
                    number: '',
                    label: '额定电压(V)',
                    color: '#FFFFFF'
                },
                {
                    icon: require('@/assets/images/exposition/chd-4.png'),
                    number: '',
                    label: '额定容量',
                    color: '#179DFF'
                },
                {
                    icon: require('@/assets/images/exposition/car-4.png'),
                    number: '',
                    label: '质保年限',
                    color: '#36FBFB'
                },
            ],
        }
    },
    mounted() {
      //获取电池信息
     this.getBatteryInfoList()
    },
    methods: {
      //获取电池信息
      getBatteryInfoList() {
        let params = {
          enCode:
            "per_vehicle-电池编码-生厂商-额定电压-额定容量-质保年限-质保里程-充电电量-累计充电",
          "@VEHICLE_VIN": localStorage.getItem("newVehicleNum")
            ? localStorage.getItem("newVehicleNum")
            : "LDP31B967MG929008",
        };
        dataInterface
          .dataFaceApi(params)
          .then((res) => {
            console.log(res, '电池信息')
            // this.batteryDataList = res[0] ? res[0] : {};
            this.target1[0].number =  res[0].battery_id || ''
            this.target1[1].number =  res[0].manufacturer_name || ''
            this.target1[2].number =  Number(res[0].rated_voltage).toFixed(0) || ''
            this.target1[3].number =  Number(res[0].rated_total_amount).toFixed(0) || ''
            this.target1[4].number =  res[0].warranty_period || ''
          })
          .catch((err) => {
            console.log(err);
          });
      },
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
.singCar-left {
    position: absolute;
    right: 0;
}
</style>